import { pm2ConfigStore } from '@pm2/store';
import { usePostloadedModal } from '@ui/kit';
import { UniversalLightboxCard } from '@utils/component-framework';
import { PostloadedIframe } from '../../../molecules/embed-iframe/atom.postloaded-iframe.js';
import { Boundary } from '../../../molecules/embed-iframe/comp.boundary.js';
import { card } from './card.style.js';
import { jsx } from 'react/jsx-runtime';

function CardPreview(props) {
  const triggerModal = usePostloadedModal();
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const handleClick = () => {
    if (props.displayData && props.target === "_blank") {
      window.open(props.displayData.src, "_blank");
    } else if (props.displayData) {
      triggerModal(/*#__PURE__*/jsx(Boundary, {
        hasPreviewImage: false,
        previewImageDimensions: undefined,
        forceOpenInLightbox: false,
        displayData: props.displayData,
        inLightbox: true,
        children: /*#__PURE__*/jsx(PostloadedIframe, {
          src: props.displayData.src,
          title: props.title
        })
      }));
    } else {
      alert("Der opstod en fejl da vi forsøgte at åbne komponenten, vi beklager. Prøv at genindlæse siden.");
    }
  };
  return /*#__PURE__*/jsx(UniversalLightboxCard, {
    className: card,
    audience: audience,
    title: props.title,
    description: props.description,
    badgeImageSrc: props.badgeImage,
    previewImageSrc: props.previewImageSrc,
    indexOrLevel: props.indexOrLevel,
    onClick: handleClick
  });
}

export { CardPreview };
//# sourceMappingURL=card.js.map
